import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  D,
  h,
  ke
} from "./chunk.FCKNEYTX.js";
import {
  n
} from "./chunk.BBN2ZB42.js";
import {
  i,
  r
} from "./chunk.FAJKIEWS.js";
import {
  __decorateClass
} from "./chunk.I4IFG4JG.js";

// src/components/jb-search-result/jb-search-result.scss?inline
var jb_search_result_default = i`*,
*::before,
*::after {
  box-sizing: border-box;
}

div,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
ol,
ul,
li,
form,
legend,
label,
table,
header,
footer,
nav,
section,
figure {
  margin: 0;
  padding: 0;
}

a {
  color: inherit;
}

/* COLOR SETTINGS */
/* shadows */
:host {
  --spacing-none: 0;
  --spacing-base: 4px;
  --spacing-3xs: 8px;
  --spacing-2xs: 12px;
  --spacing-xs: 16px;
  --spacing-s: 20px;
  --spacing-sm: 20px;
  --spacing-m: 24px;
  --spacing-lm: 28px;
  --spacing-l: 32px;
  --spacing-xl: 32px;
  --spacing-2xl: 36px;
  --spacing-3xl: 36px;
  --spacing-4xl: 72px;
  --spacing-small: var(--spacing-lm);
  --spacing-medium: var(--spacing-3xl);
  --spacing-big: var(--spacing-4xl);
  --spacing-gap: 16px;
}

@media screen and (width >= 1281px) {
  :host {
    --spacing-sm: 24px;
    --spacing-m: 32px;
    --spacing-lm: 36px;
    --spacing-l: 40px;
    --spacing-xl: 48px;
    --spacing-2xl: 64px;
    --spacing-3xl: 72px;
    --spacing-4xl: 144px;
    --spacing-small: var(--spacing-lm);
    --spacing-medium: var(--spacing-3xl);
    --spacing-big: var(--spacing-4xl);
    --spacing-gap: 40px;
  }
}
/* special measurements */
/* stylelint-disable */
/* stylelint-enable */
:host {
  --spacing-none: 0;
  --spacing-base: 4px;
  --spacing-3xs: 8px;
  --spacing-2xs: 12px;
  --spacing-xs: 16px;
  --spacing-s: 20px;
  --spacing-sm: 20px;
  --spacing-m: 24px;
  --spacing-lm: 28px;
  --spacing-l: 32px;
  --spacing-xl: 32px;
  --spacing-2xl: 36px;
  --spacing-3xl: 36px;
  --spacing-4xl: 72px;
  --spacing-small: var(--spacing-lm);
  --spacing-medium: var(--spacing-3xl);
  --spacing-big: var(--spacing-4xl);
  --spacing-gap: 16px;
}

@media screen and (width >= 1281px) {
  :host {
    --spacing-sm: 24px;
    --spacing-m: 32px;
    --spacing-lm: 36px;
    --spacing-l: 40px;
    --spacing-xl: 48px;
    --spacing-2xl: 64px;
    --spacing-3xl: 72px;
    --spacing-4xl: 144px;
    --spacing-small: var(--spacing-lm);
    --spacing-medium: var(--spacing-3xl);
    --spacing-big: var(--spacing-4xl);
    --spacing-gap: 40px;
  }
}
/* special measurements */
:host {
  color: var(--host-color, #141e55);
}

:host {
  display: block;
  margin-inline: auto;
  padding-block: 60px;
  width: 100%;
}
@media (min-width: 600px) {
  :host {
    width: 83.3%;
  }
}
@media (min-width: 960px) {
  :host {
    width: 100%;
  }
}
@media (min-width: 1281px) {
  :host {
    padding-block: 68px;
  }
}

section {
  position: relative;
}
section > div {
  box-sizing: border-box;
  display: flex;
  flex: 0 1 auto;
  flex-direction: row;
  flex-wrap: wrap;
  margin-left: auto;
  margin-right: auto;
  width: calc(100% - 2 * var(--row-small-margin, 6.68%));
}
@media (min-width: 600px) and (max-width: 959px) {
  section > div {
    width: calc(100% - 2 * 8.35%);
  }
}
@media (min-width: 1437px) {
  section > div {
    max-width: var(--row-max-width, 1436px);
  }
  section > div:not(.filtered-list) {
    width: 100%;
  }
}
@media only screen and (min-width: 960px) and (max-width: 1436px) {
  section > div {
    margin: 0 6.955%;
    max-width: calc(100% - 6.955% - 6.955%);
  }
}
@media (min-width: 600px) {
  section > div {
    box-sizing: border-box;
    display: flex;
    flex: 0 1 auto;
    flex-direction: row;
    flex-wrap: wrap;
    margin-left: auto;
    margin-right: auto;
    width: 100%;
  }
}
@media (min-width: 960px) {
  section > div {
    justify-content: center;
  }
}
section > div jb-search-input {
  --stroke-color: #d0d2dd !important;
  --fill-color: #141e55;
  display: block;
  margin-top: 1px;
  position: relative;
  width: 100%;
}
section > div jb-search-input::after {
  background-color: #d0d2dd !important;
  bottom: 0;
  content: "";
  display: inline-block;
  height: 1px;
  position: absolute;
  width: 100%;
}
@media (min-width: 600px) {
  section > div jb-search-input::after {
    left: 22px;
    width: calc(100% - 44px);
  }
}
@media (min-width: 960px) {
  section > div jb-search-input {
    padding-inline: 22px;
    width: 50%;
  }
}
section > div div.navigation-filter-wrapper {
  margin-top: 22px;
  width: 100%;
}
@media (min-width: 600px) {
  section > div div.navigation-filter-wrapper {
    margin: 14px auto 0;
    width: 65%;
  }
}
@media (min-width: 960px) {
  section > div div.navigation-filter-wrapper {
    margin-top: 36px;
  }
}
section > div div.navigation-filter-wrapper div.search-tags jb-navigation-tags {
  --row-width-mode: "full";
  --stroke-color: #d0d2dd;
}
section > div div.search-result-list-wrapper {
  box-sizing: border-box;
  flex-basis: 100%;
  max-width: 100%;
  padding: 0 0;
  width: 100%;
}
@media (min-width: 600px) {
  section > div div.search-result-list-wrapper {
    box-sizing: border-box;
    flex-basis: 100%;
    max-width: 100%;
    padding: 0 20px;
    width: 100%;
  }
}
@media (min-width: 960px) {
  section > div div.search-result-list-wrapper {
    box-sizing: border-box;
    flex-basis: 75%;
    max-width: 75%;
    padding: 0 20px;
    width: 75%;
  }
}
@media (min-width: 1281px) {
  section > div div.search-result-list-wrapper {
    box-sizing: border-box;
    flex-basis: 66.6666666667%;
    max-width: 66.6666666667%;
    padding: 0 20px;
    width: 66.6666666667%;
  }
}
@media (min-width: 1437px) {
  section > div div.search-result-list-wrapper {
    box-sizing: border-box;
    flex-basis: 58.3333333333%;
    max-width: 58.3333333333%;
    padding: 0 20px;
    width: 58.3333333333%;
  }
}
section > div div.search-result-list-wrapper jb-search-result-list {
  margin-top: 39px;
}
@media (min-width: 960px) {
  section > div div.search-result-list-wrapper jb-search-result-list {
    margin-top: 48px;
  }
}`;

// src/components/jb-search-result/jb-search-result.ts
var JbSearchResult = class extends h {
  firstUpdated() {
    if (this.searchTerm === "") return;
    this.dispatchEvent(
      new CustomEvent("jb-tracking", {
        detail: {
          event: "ce_search",
          event_version: "v2",
          component_name: "search-result",
          search_results_term: this.searchTerm,
          search_results_count: this.resultCount,
          search_results_filter: this.searchResultFilter,
          search_action: "search"
        },
        bubbles: true,
        composed: true
      })
    );
  }
  _trackFilter(evt) {
    this.dispatchEvent(
      new CustomEvent("jb-tracking", {
        detail: {
          event: "ce_search",
          event_version: "v2",
          component_name: "search-result",
          search_results_term: this.searchTerm,
          search_results_count: this.resultCount,
          search_action: "filter",
          search_results_filter: evt.detail.tag
        },
        bubbles: true,
        composed: true
      })
    );
    window.location.href = evt.detail.url;
  }
  _trackLoadMore() {
    this.dispatchEvent(
      new CustomEvent("jb-tracking", {
        detail: {
          event: "ce_search",
          event_version: "v2",
          component_name: "search-result",
          search_results_term: this.searchTerm,
          search_results_count: this.resultCount,
          search_results_filter: this.searchResultFilter,
          search_action: "more"
        },
        bubbles: true,
        composed: true
      })
    );
  }
  _trackResult(evt) {
    this.dispatchEvent(
      new CustomEvent("jb-tracking", {
        detail: {
          event: "ce_search",
          event_version: "v2",
          component_name: "search-result",
          search_results_term: this.searchTerm,
          search_results_count: this.resultCount,
          search_results_filter: this.searchResultFilter,
          search_action: "click-result",
          search_results_position: evt.detail.index,
          search_results_type: evt.detail.category,
          search_results_click_url: evt.detail.link.href
        },
        bubbles: true,
        composed: true
      })
    );
  }
  render() {
    return ke`
      <section>
        <div>
          <jb-search-input
            .autoSuggestUrl=${this.searchResultInput?.autoSuggestUrl}
            .placeholder=${this.searchResultInput?.placeholder}
            .value=${this.searchTerm}
            class="in-search-result"
          ></jb-search-input>
          <div class="navigation-filter-wrapper">
            <div class="search-tags">
              <jb-navigation-tags
                @jb-navigation-tags:filter=${this._trackFilter}
                .items=${this.navigationTagItems}
                mobileSelect
                type="with-underline mobile-select"
                class="animate-links-before"
              ></jb-navigation-tags>
            </div>
          </div>
          <div class="search-result-list-wrapper">
            <jb-search-result-list
              @jb-search:result=${this._trackResult}
              @jb-search:loadmore=${this._trackLoadMore}
              .resultCount=${this.searchResultList.resultCount}
              .resultsVisible=${this.searchResultList.resultsVisible}
              .searchResults=${this.searchResultList.searchResults ?? D}
              .loadMoreUrl=${this.searchResultList.loadMoreUrl}
              .buttonLabel=${this.searchResultList.buttonLabel}
              .labelOf=${this.searchResultList.labelOf}
              .labelResults=${this.searchResultList.labelResults}
            ></jb-search-result-list>
          </div>
        </div>
      </section>
    `;
  }
};
JbSearchResult.styles = r(jb_search_result_default);
__decorateClass([
  n({ type: Array })
], JbSearchResult.prototype, "navigationTagItems", 2);
__decorateClass([
  n({ type: Number })
], JbSearchResult.prototype, "resultCount", 2);
__decorateClass([
  n({ type: Number })
], JbSearchResult.prototype, "resultsVisible", 2);
__decorateClass([
  n()
], JbSearchResult.prototype, "searchResultFilter", 2);
__decorateClass([
  n({ type: Object })
], JbSearchResult.prototype, "searchResultInput", 2);
__decorateClass([
  n({ type: Object })
], JbSearchResult.prototype, "searchResultList", 2);
__decorateClass([
  n()
], JbSearchResult.prototype, "searchTerm", 2);
JbSearchResult = __decorateClass([
  customElement("jb-search-result")
], JbSearchResult);

export {
  JbSearchResult
};
